<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.tag"
        placeholder="名称"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-button
        class="filter-item"
        size="small"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        >搜索</el-button
      >
      <el-button type="primary" class="filter-item" size="small" @click="handleCreate">新增</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      size="large"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="ID" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.tag }}
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1" type="primary">正常</el-tag>
          <el-tag v-else type="warning">禁用</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="创建时间" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at | dateTimeFormat }}
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        width="220"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleEdit(scope.row)"
            style="width: 80px"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="warning"
            @click="handleDel(scope.row.id)"
            style="width: 80px"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog v-if="dialogFormVisible" title="编辑" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" size="mini" label-width="120px" style="width: 90%;">
        <el-form-item label="名称" prop="tag">
          <el-input type="text" v-model="form.tag" clearable/>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" class="drawer-switch" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
      },
      dialogFormVisible: false,
      form: {},
      btnLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      request({
        url: "/api/admin/tag/list",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCreate() {
      this.form = {
        tag: '',
        status: 1,
      }
      this.dialogFormVisible = true
    },
    handleEdit(object) {
      this.form = JSON.parse(JSON.stringify(object))
      this.dialogFormVisible = true
    },
    saveData() {
      request({
        url: '/api/admin/tag/save',
        method: 'post',
        data: this.form
      }).then(()=>{
        this.$message({
          type: 'success',
          message: '保存成功!'
        });
        this.dialogFormVisible = false;
        this.getList();
      })
    },
    handleDel(val) {
      this.$confirm('确定要删除, 是否继续?', '提示', {
        type: 'warning'
      }).then(() => {
        request({
          url: '/api/admin/tag/del',
          method: 'get',
          params: {id: val}
        }).then(()=>{
          this.getList()
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}
.balance {
  font-size: 18px;
  font-weight: bold;
}
</style>
